import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Grid, Row, Col, Typography } from '@sm/wds-react';
import { MobileScreen, TabletScreen } from '@sm/webassets';

import Carousel from '../../sharedComponents/MRXCarousel';
import Anchor from '../../sharedComponents/Anchor';
import { productPropType } from '../../propTypes';
import getBrowser, { BROWSER } from '../../helpers/getBrowser';
import ProductTile from './ProductTile';
import './product-category.scss';

export const TEST_ID = 'ProductCategory';

const ProductCategory = ({ products, title, description, first, anchor }) => (
  <Choose>
    <When condition={products.length}>
      <Anchor
        id={anchor}
        className={classnames({
          'sm-product-category__anchor': getBrowser() !== BROWSER.IE
        })}
      >
        <Grid
          noGutters
          noBleeds
          fluid
          className={classnames({
            'sm-product-category': true,
            'sm-product-category--first': first
          })}
          data-testid={TEST_ID}
        >
          <div className="sm-product-category__border-box" />
          <Row>
            <Col md={3} className="sm-product-category__title-col">
              <Typography component="h2" className="sm-product-category__title">
                {title}
              </Typography>
              <Typography className="sm-product-category__body">
                {description}
              </Typography>
            </Col>
            <TabletScreen>
              <Col>
                <Grid noBleeds noGutters fluid>
                  <Row>
                    {products.map((product, idx) => (
                      <Col
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${product.name}-${idx}`}
                        sm={6}
                        xl={4}
                        className="wds-flex wds-flex--x-center"
                      >
                        <ProductTile
                          title={product.name}
                          body={product.description}
                          image={product.image}
                          ctaButton={product.ctaLink}
                          link={product.learnMoreLink}
                        />
                      </Col>
                    ))}
                  </Row>
                </Grid>
              </Col>
            </TabletScreen>
          </Row>
          <MobileScreen>
            <Row>
              <Col>
                <Carousel>
                  {products.map((product, idx) => (
                    <ProductTile
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${product.name}-${idx}`}
                      title={product.name}
                      body={product.description}
                      image={product.image}
                      ctaButton={product.ctaLink}
                      link={product.learnMoreLink}
                    />
                  ))}
                </Carousel>
              </Col>
            </Row>
          </MobileScreen>
        </Grid>
      </Anchor>
    </When>
    <Otherwise />
  </Choose>
);

ProductCategory.propTypes = {
  title: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(productPropType).isRequired,
  description: PropTypes.string.isRequired,
  first: PropTypes.bool.isRequired,
  anchor: PropTypes.string.isRequired
};

export default ProductCategory;
